<template>
    <div>
        <b-card title="History" v-if="history">
            <b-table striped hover :items="history" :fields="fields" :current-page="currentPage" :per-page="10">
                <template v-slot:cell(crossSellBrand)="data">
                    {{ data.item.crossSellBrand }}
                </template>
                <template v-slot:cell(createDate)="data">
                    {{ getDate(data.item.createdDate) }}
                </template>
                <template v-slot:cell(message)="data">
                    {{ data.item.message }}
                </template>
                <template v-slot:cell(createUser)="data">
                    {{ data.item.createdUser }}
                </template>
            </b-table>

            <b-pagination v-model="currentPage" :total-rows="history.length" :per-page="10" first-number
                last-number></b-pagination>
        </b-card>
    </div>


</template>


<script>
import { format } from "date-fns";
export default {
    components: {},
    props: {
        history: null,
    },
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            currentPage: 1,
            fields: [
                { key: "crossSellBrand", label: "Brand" },
                { key: "createDate", label: "Date" },
                { key: "message", label: "Message" },
                { key: "createdUser", label: "User" },
            ],

        }
    },
    methods: {
        getDate(date) {
            return format(new Date(date), "dd/MM/yyyy HH:mm");
        },
    }
}
</script>